import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";
import DiscoImg from "images/png/discography-image.png";

const DiscographyEmptyState = ({ AddDisabled }: { AddDisabled: boolean }) => {
  const navigate = useNavigate();
  return (
    <Container>
      <Body>
        <Image src={DiscoImg} alt="discography-image" />
        <Typography
          weight="medium"
          size="2xl"
          align="center"
          mb="0.8"
          color={Colors.grey100}
        >
          You don’t have any releases yet
        </Typography>
        <Typography mb="2.4" size="lg" color={Colors.grey400}>
          Upload your first Single, EP or Album on rated afrika
        </Typography>
        <PrimaryButton
          text="Create New Release"
          inset
          sparkle
          onClick={() => navigate("/overview/upload-music")}
          disabled={AddDisabled}
        />
      </Body>
    </Container>
  );
};

export default DiscographyEmptyState;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const Image = styled.img`
  width: 16rem;
  object-fit: scale-down;
`;
